var app = angular.module("leonardo");

var TaskResolveDialog = function($scope, $rootScope, $q, $state, ngDialog, NoteService, AttachmentService, TaskService,
                                 NotificationService, WorkFlowService, FormErrorsService, DynamicFormDataRestService, PermissionService,
                                 $filter, AnalyticsService, StatsigService, WorkOrderProviderService, AuthDataService) {
  $scope.task = $scope.ngDialogData.task;
  $scope.is_mrb = $scope.ngDialogData.is_mrb;
  $scope.workOrder = $scope.ngDialogData.work_order;
  $scope.fallback_approvers = $scope.ngDialogData.fallback_approvers;
  $scope.taskService = TaskService;
  $scope.data = {};
  $scope.attachments = [];
  $scope.attachments_note = [];
  $scope.resolution_format = 'minutes';
  $scope.permissionService = PermissionService;
  $scope.WorkFlowService = WorkFlowService;
  $scope.loading = false;

  angular.forEach($scope.task.attachments, function(attachment) {
    $scope.attachments.push(attachment);
  });
  if (!isEmpty($scope.task.next_approvers)) {
    $scope.data.next_approver = $scope.task.next_approvers.map(user => $filter('username')(user) + ' - ' + user.email).join(', ');
  }
  else if (!isEmpty($scope.fallback_approvers)) {
    let approvers = Object.keys($scope.fallback_approvers);
    $scope.data.next_approver = $scope.fallback_approvers[approvers[0]].map(user => $filter('username')(user) + ' - ' + user.email).join(', ');
  }

  $scope.changeResolutionFormat = function(type){
    $scope.resolution_format = type;
  };

  $scope.getTimeElapsed = function() {
    return moment($scope.task.last_start_time).fromNow(true);
  };

  $scope.removeAttachment = function(index) {
    $scope.attachments.splice(index, 1);
  };

  $scope.removeAttachmentNote = function(index) {
    $scope.attachments_note.splice(index, 1);
  };

  $scope.showAttachFileDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/attachment/upload.html',
      controller: 'AttachmentUploadDialog',
      className: 'ngdialog-theme-default ngdialog-attachments-view',
      data: {task: {}, mode: 'upload_note'}
    }).then(function(attachments) {
      angular.forEach(attachments, function(attachment) {
        $scope.attachments.push(attachment);
      });
    });
  };

  $scope.showAttachNoteFileDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/attachment/upload.html',
      controller: 'AttachmentUploadDialog',
      data: {task: {}, mode: 'upload_note'}
    }).then(function(attachments) {
      angular.forEach(attachments, function(attachment) {
        $scope.attachments_note.push(attachment);
      });
    });
  };

  $scope.notesRequired = function () {
    return (!$scope.task.notes || ($scope.task.notes.length === 0)) && $scope.task.note_required;
  };

  $scope.notesLabel = function() {
    var label = $filter('translate')('Add a note (optional)');
    if ($scope.notesRequired()) {
      label = $filter('translate')('Add a note (required)');
    }
    return label;
  };

  $scope.noteInvalid = function() {
    return ($scope.notesRequired() && !$scope.data.text);
  };

  $scope.notesWithAttachments = function () {
    var attachments = false;
    if ($scope.task.notes) {
      angular.forEach($scope.task.notes, function (note) {
        if (note.attachments && (note.attachments.length > 0)) {
          attachments = true;
        }
      });
    }
    return attachments;
  };

  $scope.attachmentsRequired = function () {
    return !$scope.notesWithAttachments() && $scope.task.attachment_required;
  };

  $scope.attachmentInvalid = function() {
    return ($scope.attachmentsRequired() && ($scope.attachments_note.length === 0));
  };

  $scope.getParentType = function() {
    switch ($scope.task.type_task.toString()) {
      case TaskService.TYPE_TASK_DEFAULT:
        return TaskService.PARENT_TYPE_TASK;
      case TaskService.TYPE_TASK_DOCUMENT:
        return TaskService.PARENT_TYPE_DOCUMENT;
      case TaskService.TYPE_TASK_WORKFLOW:
        return TaskService.PARENT_TYPE_WORKFLOW;
      default:
        break;
    }
  };

  $scope.showCreateWorkOrder = async function () {
    var didActivateGate = false;
    function cleanupGate() {
      if (didActivateGate) {
        StatsigService.deactivateContextualGate('work_orders_new_experience');
        didActivateGate = false;
      }
    }
    try {
      var inIframe = false;
      try {
        inIframe = window.self !== window.top;
      } catch (e) {
        inIframe = true;
      }

      const useNewExperience = inIframe ? true : await StatsigService.checkGate('work_orders_new_experience');

      if (!inIframe && useNewExperience) {
        StatsigService.activateContextualGate('work_orders_new_experience');
        didActivateGate = true;
      }
      
      WorkOrderProviderService.openWorkOrder({
        useExpoIntegration: useNewExperience,
        action: 'create',
        data: {
          task: $scope.task,
          property: $scope.task.property,
          unit: $scope.task.unit_id
        },
        closeCallback: function(result) {
          cleanupGate();
        }
      }).catch(function() {
        cleanupGate();
      });
    } catch (error) {
      console.error('[WORK_ORDER] Failed to open work order:', error);
      cleanupGate();
    }
  };

  $scope.launchWorkflow = function(result){
    var items_ids = [];
    angular.forEach(result.workflow_instance.active_templates, function(value){
      items_ids.push(value.id);
    });
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/launch.html',
      controller: 'LaunchWorkFlowDialog',
      data: {
        workflow: result.workflow_instance,
        items: items_ids,
        property: result.property,
        unit: result.workflow_instance.unit ? result.workflow_instance.unit.id : null,
        workflow_id: result.workflow_instance.workflow,
        is_launch_trigger_wfs: true,
        is_mrb: $scope.is_mrb,
        context: 'Tasks Page'
      }
    }).then(function (){
      // This is intentional do_something blank function
    });
    $scope.closeThisDialog();
  };

  $scope.getData = function () {
    var defer = $q.defer();
    var data = angular.copy($scope.data);

    if ($scope.resolution_format === 'hours') {
      data['resolution_time'] *= 60;
    }
    data['completed_date'] = moment().format('YYYY-MM-DD');
    if ($scope.task.has_approval_config) {
      data['status'] = TaskService.STATUS_APPROVAL_IN_PROGRESS;
      if (!isEmpty($scope.fallback_approvers)) {
        let approvers = Object.keys($scope.fallback_approvers);
        angular.forEach(approvers, function (key) {
          $scope.fallback_approvers[key] = $scope.fallback_approvers[key].map(user => user.id ? parseInt(user.id) : parseInt(user));
        })
        if(Object.keys($scope.fallback_approvers).length > 0){
          data['fallback_approvers'] = [];
          for (const fallback_approvers in $scope.fallback_approvers) {
            data['fallback_approvers'].push($scope.fallback_approvers[fallback_approvers][0]);
          }
        }
      }
    }
    else {
      data['status'] = TaskService.STATUS_SOLVED;
    }

    if($scope.workOrder){
      data['account'] = $scope.workOrder.account;
      data['technician_notes'] = $scope.workOrder.technician_notes;
      data['requester_name'] = $scope.workOrder.requester_name;
      data['general_repairs'] = $scope.workOrder.general_repairs;
      data['reason'] = $scope.workOrder.reason;
    }

    var promises = [];
    data['attachments'] = [];
    angular.forEach($scope.attachments, function(attachment) {
      data['attachments'].push(attachment);
    });

    if (data['text'] || $scope.attachments_note.length > 0) {
      if (!data['text']) {
        data['text'] = '';
      }

      var attachments_note = [];
      angular.forEach($scope.attachments_note, function(attachment) {
        if (attachment.document_folder || attachment.document_file) {
          promises.push(AttachmentService.linkTo(attachment).then(function(response){
            attachments_note.push(response.data.id);
          },function (){
            attachments_note = attachments_note;
          }));
        }
        else if (attachment.link) {
          promises.push(AttachmentService.post(attachment.name, null, attachment.link, attachment.available_for_account).then(function(response){
            attachments_note.push(response.data.id);
          },function (){
            attachments_note = attachments_note;
          }));
        }
        else {
          promises.push(AttachmentService.post(attachment.name, attachment.file, null, attachment.available_for_account).then(function(response){
            attachments_note.push(response.data.id);
          },function (){
            attachments_note = attachments_note;
          }));
        }
      });
      $q.all(promises).then(function(){
        if($scope.attachments_note.length == attachments_note.length){
          data['attachments'] = attachments_note;
          data['actionitem_set'] = [];
          data['actionitem_set'].push($scope.task.id);
          NoteService.post(data).then(function(note) {
            delete (data['attachments']);
            delete (data['actionitem_set']);
            delete (data['text']);
            data['note_added'] = true;
            $scope.task.notes.push(note);
            defer.resolve(data);
          },function (){
            defer.resolve(data);
          });
        }
        else{
          defer.resolve({});
        }
      },function (){
        defer.resolve((attachments_note > 0) ? data : {});
      });
    }
    else {
      $q.all(promises).then(function(){
        if ($scope.task.notes.length > 0) {
          data['note_added'] = true;
        }
        defer.resolve(data);
      },function (){
        defer.resolve(data);
      });
    }
    return defer.promise;
  };

  $scope.submit = function() {
    if ($scope.loading) return; // Prevent multiple submissions
    
    $scope.Form.$setSubmitted();
    if($scope.noteInvalid() || $scope.attachmentInvalid()) {
      return;
    }
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.loading = true;
    $scope.getData().then(function (data) {
      if (isEmpty(data)) {
        $scope.loading = false;
        NotificationService.notify('error', 'Oops! The attached file(s) were not successfully uploaded.</br>' + 'Please re-attach the file(s) and try your submission again. Contact help@leonardo247.com for assistance if needed.', '', 10000);
        return;
      }
      $scope.task.resolveTask(data).then(function(data_result) {
        $scope.loading = false;
        var result = data_result.data ? data_result.data : data_result;
        if(result.workflow_status == 4 && result.can_launch_trigger_wfs){
          $scope.launchWorkflow(result);
        }
        $scope.task.status = result.status;
        $rootScope.$broadcast('task-resolve-dialog:success', $scope.task);
        AnalyticsService.track("Task Marked Complete", {
          ...AnalyticsService.getTaskGroupProperties(data_result),
          cannot_do : false,
          copy_supervisor : data.important || false,
          days_late : AnalyticsService.calculateDaysLate(data_result.due_date),  
        })

        $scope.closeThisDialog();
      });
    })
  };

  $scope.submitApproval = function () {
    $scope.Form.$setSubmitted();
    if($scope.noteInvalid() || $scope.attachmentInvalid()) {
      return;
    }
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }

    $scope.getData().then(function (data) {
      if (isEmpty(data)) {
        NotificationService.notify('error', 'Oops! The attached file(s) were not successfully uploaded.</br>' + 'Please re-attach the file(s) and try your submission again. Contact help@leonardo247.com for assistance if needed.', '', 10000);
        return;
      }
      $scope.task.requestApproval(data).then(function(data_result) {
        var result = data_result.data ? data_result.data : data_result;
        $scope.task.status = result.status;
        $rootScope.$broadcast('task-request-approval-dialog:success', $scope.task);
        $scope.closeThisDialog();
      });
    });
  }

};

app.controller('TaskResolveDialog', ['$scope', '$rootScope', '$q', '$state', 'ngDialog', 'NoteService', 'AttachmentService',
  'TaskService', 'NotificationService', 'WorkFlowService', 'FormErrorsService', 'DynamicFormDataRestService', 'PermissionService', '$filter', 'AnalyticsService',
  'StatsigService', 'WorkOrderProviderService', 'AuthDataService', TaskResolveDialog]);
